import { TokenIconProvider } from "@cede/types";
import { CoinMarketCapTokensResponse } from "./coinmarkercap.provider.type";

export class CoinMarketCapProvider implements TokenIconProvider {
  private endpoint = "https://api.coinmarketcap.com/data-api/v3/uniswap/all.json";

  async fetch() {
    const res: CoinMarketCapTokensResponse = await fetch(this.endpoint).then((res) => res.json());

    const tokens = res.tokens;

    return tokens.map((token) => ({
      token: token.symbol,
      icon: token.logoURI,
    }));
  }
}
